export default __webpack_public_path__ + "static/media/taskam2.a5a5065e.png";